import { IAPReward, IRewardData } from '../../../Utility/RewardHelper';
import { RewardType } from '../../../Utility/Rewards/RewardType';
import { trackPurchase, trackResourceEvent } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import Game from '../../../Game';
import { IAPProduct } from '../../../Utility/SDK/Drivers/IAPCatalog';
import { clearTrackingData, track } from '../../../Utility/Tracking/Track';
import { TActionType, TransactionType } from '../../../Utility/Tracking/DataSet/Transaction';
import { trackReward } from '../../../Utility/Tracking/TrackingHelpers/Resource';
import { GameActions } from 'State/Game/GameActions';
import { TransactionDataHandler } from 'Utility/Tracking/Handler/Transaction';
import { ProductId } from 'Utility/Product';

export function trackWheelResourceEvent(props: { rewards: IRewardData[]; tActionType: TActionType }): void {
    track('tCoinsUsed', 0); // fix coins used not 0 with resource reward event SOFA-612

    trackResourceEvent(Game.store.getState(), {
        transactionType: TransactionType.REWARD,
        tActionType: props.tActionType,
    });
}

export function trackPremiumSpinPurchase(props: {
    iapProduct: IAPProduct;
    iapReward: IAPReward;
    tActionType: TActionType;
}): void {
    const reward = { type: RewardType.PRIZE_WHEEL_SPIN, value: 1 };
    let state = Game.store.getState();
    track('tProductID', props.iapProduct.productId);
    trackPurchase(state, props.iapProduct.productId as ProductId, [reward], props.tActionType);
    clearTrackingData(TransactionDataHandler);
    GameActions.setState(state);
}
